// NOTE: name should be lowercase as lowercase serializer is used.
export const LEADERSHIP_SERIES_ROUTE = {
  name: 'leadershipseries',
  route(): string[] {
    return ['/' + this.name];
  },
  ABOUT: {
    name: 'about',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  CONTENT: {
    name: 'content/:contentid',
    route(contentId: string): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), 'content', contentId];
    }
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  EXPERTS: {
    name: 'experts',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  PODCAST: {
    name: 'podcast/:contentid',
    route(contentId: string): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), 'podcast', contentId];
    }
  },
  PODCASTS: {
    name: 'podcasts',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  RESOURCES: {
    name: 'resources',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  ROUNDTABLES: {
    name: 'roundtables',
    route(): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), this.name];
    }
  },
  VIDEO: {
    name: 'video/:contentid',
    route(contentId: string): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), 'video', contentId];
    }
  },
  WEBINAR: {
    name: 'webinar/:contentid',
    route(contentId: string): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), 'webinar', contentId];
    }
  },
  WEBINAR_LOAD: {
    name: ':collectionid/webinarload/:contentid',
    route(collectionId: string, contentId: string): string[] {
      return [...LEADERSHIP_SERIES_ROUTE.route(), collectionId, 'webinarload', contentId];
    }
  }
};
